import { Box, Typography } from '@mui/material';
import { BORDER_RADIUS } from '../../../constants/styles';

export const CardContent = ({ title, subtitle, titleImage, isSpecialTitle, alignTop }) => {
  const contentStyle = {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    width: '100%',
    height: '100%',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: alignTop ? 'flex-start' : 'flex-end',
    alignItems: 'flex-start',
    background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, rgba(0,0,0,0) 100%)',
    boxSizing: 'border-box',
    overflow: 'hidden',
    borderRadius: BORDER_RADIUS
  };

  const titleWrapperStyle = {
    width: '100%',
    marginBottom: '8px'
  };

  const titleImageStyle = {
    width: '100%',
    maxWidth: isSpecialTitle ? '280px' : '250px',
    height: 'auto',
    objectFit: 'contain',
    filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.2))'
  };

  return (
    <Box sx={contentStyle}>
      <Box sx={titleWrapperStyle}>
        {titleImage ? (
          <Box
            component="img"
            src={titleImage}
            alt={title}
            sx={titleImageStyle}
          />
        ) : (
          <Typography 
            variant={isSpecialTitle ? "h4" : "h6"}
            sx={{ 
              background: isSpecialTitle 
                ? 'linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 30%, #FFE387 100%)'
                : 'linear-gradient(to bottom, #FFFFFF 0%, #FFFFFF 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)',
              fontWeight: 'normal',
              fontFamily: isSpecialTitle ? '"Luckiest Guy", cursive' : 'inherit',
              fontSize: isSpecialTitle ? '5rem' : undefined,
              letterSpacing: isSpecialTitle ? '0.05em' : undefined,
            }}
          >
            {title}
          </Typography>
        )}
      </Box>
      <Typography 
        variant="subtitle1" 
        sx={{ 
          color: 'white',
          opacity: 0.8,
          textShadow: '0 1px 2px rgba(0,0,0,0.3)'
        }}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}; 